import { inject, Injectable } from '@angular/core';
import { MatDateFormats, NativeDateAdapter } from '@angular/material/core';
import { DateService } from '../shared/services/date.service';

@Injectable()
export class DhigDateAdapter extends NativeDateAdapter {
  private dateService = inject(DateService);

  override parse(value: any): Date | null {
    return this.dateService.parseToDate(value);
  }

  override format(date: Date, displayFormat: Object): string {
    if (!date) {
      return '';
    }

    if (displayFormat === 'input') {
      return this.dateService.formatToDateString(date);
    } else {
      return date.toDateString();
    }
  }
}

export const DHIG_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: { year: 'numeric', month: 'numeric', day: 'numeric' },
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};
